import { render } from "./ActivityLogResourceSelect.vue?vue&type=template&id=859a5756"
import script from "./ActivityLogResourceSelect.vue?vue&type=script&lang=js"
export * from "./ActivityLogResourceSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__